import "./../App.css"
import Header from "../components/Header"
import CalendarComponent from "../components/TournamentComponents/CalendarComponent"
import { Typography } from "@mui/material"

function TournamentsPage() {
	return (
		<div className="content">
			<Header title="Torneos" />
			<br></br>
			<Typography>
				Aqui puedes encontrar todos los torneos en los que el club tiene
				intención de participar!
			</Typography>
			<CalendarComponent />
			<br></br>
		</div>
	)
}
export default TournamentsPage
